import React, { useState } from 'react';
import cartisan from '../img/cartisan-logo-black.svg';
import nswlogo from '../img/NSWGov.svg';
import apralogo from '../img/apra.png';



const rtnmap = (window as any).rtnmap || {};
export const AboutTab: React.FC = () => {
    const [expandedPanel, setExpandedPanel] = useState<number>(0);
    return <>
				<div className="title-block flex flex-col container-margin -mt-1">
					<button onClick={() => setExpandedPanel(expandedPanel === 0 ? 1 : 0)} className="text-left">
							<div className="flex flex-row items-center border-black py-4">
									<div className="flex-1">
											<h3 className="heading-3">Resources</h3>
									</div>
									<div>
											<div className="text-xl">
													<i className={`fal fa-chevron-up transition-all ${expandedPanel === 1 ? 'rotate-0' : 'rotate-180'}`}></i>
											</div>
									</div>
							</div>
					</button>
        </div>
        <div className={`${expandedPanel === 1 ? 'flex-grow h-full scrolling-touch overflow-y-auto opacity-100' : 'flex-shrink h-0 overflow-hidden opacity-0'} transition-all`}>
            <div className="scrolling-touch h-full overflow-y-auto about-panel">
                <div className="container-margin my-2 flex-grow underlined-links" dangerouslySetInnerHTML={{ __html: rtnmap?.resourcesPage?.html }}></div>
            </div>
        </div>
        <div className="title-block flex flex-col container-margin">
            <button onClick={() => setExpandedPanel(expandedPanel === 0 ? 1 : 0)} className="text-left">
                <div className="flex flex-row items-center py-4 border-t border-black">
                    <div className="flex-1">
                        <h3 className="heading-3">About</h3>
                    </div>
                    <div>
                        <div className="text-xl">
                            <i className={`fal fa-chevron-up transition-all ${expandedPanel === 0 ? 'rotate-0' : 'rotate-180'}`}></i>
                        </div>
                    </div>
                </div>
            </button>
        </div>
        <div className={`${expandedPanel === 0 ? 'flex-grow h-full scrolling-touch overflow-y-auto opacity-100' : 'flex-shrink h-0 overflow-hidden opacity-0'} transition-all`}>
            <div className="scrolling-touch h-full overflow-y-auto about-panel">
                <div className="container-margin my-2 flex-grow" dangerouslySetInnerHTML={{ __html: rtnmap?.aboutPage?.html }}>
                </div>
								<div className="container-margin mb-8 flex flex-wrap items-center mt-10">
									<div className="text-sm sm:text-base font-bold w-full mb-3 uppercase">Supported By</div>
									<img className="w-10 h-inherit mr-6" src={nswlogo} alt="Create NSW" />
									<img className="h-9 h-inherit" src={apralogo} alt="APRA AMCOS" />
								</div>
            </div>
        </div>
        <div className="container-margin mb-4 small-copy opacity-40">
            <a className="mt-4 w-1/5 inline-block" href="https://cartisan.io" rel="noreferrer" target="_blank"><img src={cartisan} alt="Cartisan" /></a>
        </div>
    </>
}